/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Creditpackbooked2Inputs */

const en_creditpackbooked2 = /** @type {(inputs: Creditpackbooked2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits are now in your balance.`)
};

const de_creditpackbooked2 = /** @type {(inputs: Creditpackbooked2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} Credits sind jetzt in deinem Guthaben.`)
};

/**
* | output |
* | --- |
* | "{credits} credits are now in your balance." |
*
* @param {Creditpackbooked2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpackbooked2 = /** @type {((inputs: Creditpackbooked2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpackbooked2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpackbooked2(inputs)
	return de_creditpackbooked2(inputs)
});
export { creditpackbooked2 as "creditPackBooked" }